import jQuery from "jquery";

const $ = jQuery;

const Invoca = {};

function isElementInViewport(elem) {
  var $elem = jQuery(elem);

  if ($elem.length > 0) {
    var rect = $elem[0].getBoundingClientRect();
    var $window = jQuery(window);

    return rect.bottom > $elem.outerHeight() &&
      rect.right > 0 &&
      rect.left < $window.width() &&
      rect.top < $window.height();
  }

  return false;
}

Invoca.smoothScrollTo = function(elem) {
  var $elem = jQuery(elem);
  if (!$elem.length) {
    return;
  }

  var topMargin = 0;

  if ($("#header").hasClass("nav-overlay")) {
    topMargin = $("#header ul.nav").height();
  }

  var top = $elem.closest(".flash-row").length ? 0 : ($elem.offset().top - topMargin);

  if (!isElementInViewport(elem) || top === 0) {
    jQuery('html, body').stop().animate({
      'scrollTop': top
    }, 500, 'swing');
  }
};

export default Invoca;
